import { useImperativeHandle, forwardRef, useState, useEffect } from 'react';
import classNames from 'classnames';
import styles from './FJCheckBoxRound.module.less';

function FJCheckBoxRound(props, ref) {
    const {
        selected: defaultSelected = false,
        value = '',
        style,
        dataChange,
        className,
        iconClassName,
        textClassName,
    } = props;
    const [isSelected, setSelected] = useState(defaultSelected);

    useEffect(() => {
        setSelected(defaultSelected);
    }, [defaultSelected]);

    useImperativeHandle(ref, () => ({
        selected: () => {
            return isSelected;
        },
        value: () => {
            return value;
        },
        select: () => {
            setSelected(true);
        },
        deselect: () => {
            setSelected(false);
        },
    }));

    const _handleClick = e => {
        setSelected(!isSelected);
        if (dataChange) {
            dataChange(!isSelected, e);
        }
    };

    return (
        <div
            onClick={_handleClick}
            className={classNames(styles.check_box, className, isSelected ? styles.selected : '')}
            style={style}
        >
            <div className={classNames(styles.check_box_select, iconClassName)}>
                <div className={styles.check_box_select_inner}></div>
                <div className={styles.check_box_select_inner_2}></div>
            </div>
            {value && <span className={classNames(styles.check_box_value, textClassName)}>{value}</span>}
        </div>
    );
}

export default forwardRef(FJCheckBoxRound);
